"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageSidebar = void 0;
const react_1 = __importDefault(require("react"));
const classFunctions_1 = require("../../../utils/classFunctions");
const Controls_1 = require("./Controls");
const Navigation_1 = require("./Navigation");
require("./index.scss");
const className = 'page-sidebar';
class PageSidebar extends react_1.default.PureComponent {
    render() {
        const { navDisabled, modificators, routeItems, isRouteMatch, handleLogout, ...restProps } = this.props;
        const classNames = (0, classFunctions_1.getClassNames)(className, modificators);
        return (react_1.default.createElement("div", { className: classNames },
            react_1.default.createElement("div", { className: `${className}__navigation` },
                react_1.default.createElement(Navigation_1.PageSidebarNavigation, { isDisabled: navDisabled, isRouteMatch: isRouteMatch, routeItems: routeItems, ...restProps })),
            react_1.default.createElement("div", { className: `${className}__controls` },
                react_1.default.createElement(Controls_1.PageSidebarControls, { handleLogout: handleLogout }))));
    }
}
exports.PageSidebar = PageSidebar;
PageSidebar.defaultProps = {
    navDisabled: false,
    isRouteMatch: () => false,
};
//# sourceMappingURL=index.js.map